import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useUser  } from '../UserContext';
import { toast } from 'react-toastify'; // Import toast

const CardUpdateForm = ({ closeModal, facilityId, subscriptionId }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const facility = useUser ();
    const facilityData = facility?.user?.facility;
    const finalFacilityId = facilityData?.id || facilityId;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        if (!stripe || !elements) return;

        const cardElement = elements.getElement(CardElement);

        // Create a payment method with the card details
        const { paymentMethod, error } = await stripe.createPaymentMethod({
            type: "card",
            card: cardElement,
        });

        if (error) {
            setLoading(false);
            toast.error("Error creating payment method: " + error.message); // Show error toast

            // alert("Error creating payment method: " + error.message);
        } else {
            
            // Send subscription_id & facility_id to backend
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/subscriptions/save_card/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    payment_method_id: paymentMethod.id,
                    facility_id: finalFacilityId,
                    subscription_id: subscriptionId,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                toast.success("Card updated successfully!"); // Show success toast

                closeModal(); // Close the modal after successful update
            } else {
                alert("Failed to update card: " + (data.error || "Unknown error"));
            }
        }

        setLoading(false);
    };

    const cardElementOptions = {
        style: {
            base: {
                color: "#32325d",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                lineHeight: "24px",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                // Add more styles as needed
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        },
    };

    return (
        <form onSubmit={handleSubmit} className="card-update-form">
            <label htmlFor="card-element">Credit or debit card</label>
            <CardElement options={cardElementOptions} />
            <button type="submit" disabled={!stripe || loading} className="btn btn-primary">
                {loading ? "Updating..." : "Update Card"}
            </button>
        </form>
    );
};

export default CardUpdateForm;